if (!customElements.get('brand-product-gallery')) {
  customElements.define(
    'brand-product-gallery',
    class BrandProductGallery extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.brand-product-gallery__stage');
        this.thumbs = this.querySelectorAll('.brand-product-gallery__thumb');
        this.slides = this.querySelectorAll('.brand-product-gallery__slide');

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.mediaId));
        });

        this.variantChangeHandler = this.onVariantChange.bind(this);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.variantChangeHandler);
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      onVariantChange({ data }) {
        const mediaId = data?.variant?.featured_media?.id;
        if (mediaId) this.setActiveMedia(String(mediaId));
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;
        const id = String(mediaId);

        this.slides.forEach((slide) => {
          const active = String(slide.dataset.mediaId) === id;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('hidden', !active);

          if (!active) {
            slide.querySelectorAll('deferred-media[loaded]').forEach((media) => {
              const player = media.querySelector('video, iframe');
              if (player?.tagName === 'VIDEO') player.pause();
            });
          }
        });

        this.thumbs.forEach((thumb) => {
          const active = String(thumb.dataset.mediaId) === id;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });

        const activeSlide = this.querySelector(`.brand-product-gallery__slide[data-media-id="${id}"]`);
        const deferredMedia = activeSlide?.querySelector('deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }
    }
  );
}
